module.exports = __webpack_public_path__ + "static/img/double_fun_shape_2.6c7560d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/double_fun_shape_2.png
// module id = skMB
// module chunks = 0